import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "text-truncate" }
const _hoisted_2 = { class: "text-truncate" }
const _hoisted_3 = { class: "text-truncate" }
const _hoisted_4 = { class: "text-truncate" }
const _hoisted_5 = {
  key: 0,
  class: "text-truncate"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-play ms-1" }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "text-truncate" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-cloud-download fs-2 text-primary" }, null, -1)
const _hoisted_13 = [
  _hoisted_12
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GenerateReportIcon = _resolveComponent("GenerateReportIcon")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_vz_audio_modal = _resolveComponent("vz-audio-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Datatable, {
      "table-data": _ctx.tableData,
      "table-header": _ctx.tableHeader,
      total: _ctx.total,
      rowsPerPage: _ctx.rowsPerPage,
      page: _ctx.page,
      loading: _ctx.loading,
      showSearch: _ctx.showSearch,
      defaultFilter: _ctx.defaultFilter,
      tableFilter: _ctx.tableFilter,
      bulkDelete: _ctx.bulkDelete,
      viewName: "formDocuments",
      onQueryUpdate: _ctx.queryUpdate
    }, {
      "cell-documentName": _withCtx(({ row: document }) => [
        _createElementVNode("span", _hoisted_1, _toDisplayString(document.documentName), 1)
      ]),
      "cell-siteName": _withCtx(({ row: document }) => [
        _createElementVNode("span", _hoisted_2, _toDisplayString(document.siteName), 1)
      ]),
      "cell-userName": _withCtx(({ row: document }) => [
        _createElementVNode("span", _hoisted_3, _toDisplayString(document.userName), 1)
      ]),
      "cell-startDate": _withCtx(({ row: document }) => [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.format.convertUTCToLocalDate(document.startDate, "MM-DD-YYYY hh:mm A")), 1)
      ]),
      "cell-audio": _withCtx(({ row: document }) => [
        (
          document.file &&
          document.file.some((file) => file.content_type === 'audio/vnd.wave')
        )
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
              _createElementVNode("a", {
                class: "btn btn-icon btn-primary btn-circle btn-sm",
                onClick: _withModifiers(($event: any) => (_ctx.setAudioData(document)), ["stop"])
              }, _hoisted_8, 8, _hoisted_6)
            ]))
          : _createCommentVNode("", true)
      ]),
      "cell-endDate": _withCtx(({ row: document }) => [
        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.format.convertUTCToLocalDate(document.endDate, "MM-DD-YYYY hh:mm A")), 1)
      ]),
      "cell-status": _withCtx(({ row: document }) => [
        _createElementVNode("span", {
          class: _normalizeClass(["text-truncate fw-bolder", {
          'badge badge-success bg-success':
            document.scheduleStatus === 'ON_TIME' || 'OUTSIDE_PERIOD',
          'badge badge-danger bg-danger': document.scheduleStatus === 'EXPIRED',
          'badge badge-info bg-info': document.scheduleStatus === 'SCHEDULE',
        }])
        }, _toDisplayString(document.scheduleStatus === "ON_TIME"
            ? "Completed"
            : document.scheduleStatus === "OUTSIDE_PERIOD"
            ? "Completed"
            : _ctx.format.TitleCase(document.scheduleStatus?.toLowerCase())), 3)
      ]),
      "cell-generatePDF": _withCtx(({ row: document }) => [
        (
          !(document.file && document.file?.find((f) => f.key)) &&
          document.status?.toLowerCase() === 'completed'
        )
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              class: "cursor-pointer align-top",
              onClick: _withModifiers(($event: any) => (_ctx.generatePDF(document)), ["stop"]),
              title: "Regenerate Report"
            }, [
              _createVNode(_component_GenerateReportIcon)
            ], 8, _hoisted_10))
          : _createCommentVNode("", true),
        (
          document.file &&
          document.file?.find((f) => f.key) &&
          document.status?.toLowerCase() === 'completed'
        )
          ? (_openBlock(), _createElementBlock("a", {
              key: 1,
              class: "cursor-pointer",
              title: "Download Report",
              onClick: _withModifiers(($event: any) => (_ctx.downloadFile(document.file)), ["stop"])
            }, _hoisted_13, 8, _hoisted_11))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["table-data", "table-header", "total", "rowsPerPage", "page", "loading", "showSearch", "defaultFilter", "tableFilter", "bulkDelete", "onQueryUpdate"]),
    _createVNode(_component_vz_audio_modal, {
      audioId: _ctx.audioId,
      showDialog: _ctx.showAudioDialog,
      onModalClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showAudioDialog = false)),
      onCloseDetail: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showAudioDialog = false))
    }, null, 8, ["audioId", "showDialog"])
  ], 64))
}